module.exports = __webpack_public_path__ + "img/bom-5.daf892cc.png";